export default __webpack_public_path__ + "static/media/sara_hall.d2401e5e.png";